var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPessoaEmPe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 468,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.758 77.4054a27.5422 27.5422 0 0 0 5.257-11.56 27.5436 27.5436 0 0 0-.485-12.6903 27.5572 27.5572 0 0 0-6.126-11.1242 27.5564 27.5564 0 0 0-10.465-7.1948 6.9622 6.9622 0 0 0-.669-10.6935 6.9603 6.9603 0 0 0-3.79-1.331 19.8204 19.8204 0 0 0-.964-9.7652 19.8112 19.8112 0 0 0-5.529-8.1067A19.8198 19.8198 0 0 0 134.44.7547a19.8171 19.8171 0 0 0-8.474 4.947 19.823 19.823 0 0 0-5.064 8.4055 19.826 19.826 0 0 0-.411 9.804 19.8214 19.8214 0 0 0 4.34 8.8002 13.125 13.125 0 0 0-7.324 4.6029 13.1227 13.1227 0 0 0-2.87 8.1611 13.1286 13.1286 0 0 0 2.831 8.1746 13.123 13.123 0 0 0 7.303 4.6375 12.797 12.797 0 0 0 1.704.2709 27.5553 27.5553 0 0 0 5.669 18.7956l21.877 7.6444 21.737-7.593Z",
    fill: "#0D1317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.289 126.391 243.13 73.4081a35.2194 35.2194 0 0 0-35.326-7.21l-53.798 18.8003-53.803-18.8003a35.2169 35.2169 0 0 0-35.3249 7.21L6.714 126.391C-4.7125 136.8-.5098 155.684 14.2507 160.26l63.0392 18.53 14.4756-38.978v97.756H216.256v-101.74l12.954 44.722 64.547-20.304c14.746-4.576 18.949-23.46 7.532-33.855Z",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9586 127.927c.2662 0-27.275-9.774-27.275-9.774",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.718 129.263c-.27 0 32.379-11.586 32.379-11.586",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.247 85.3719s-1.517 7.0046-9.601 7.7518",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.118 71.7457c2.347 0 4.25-1.9026 4.25-4.2495s-1.903-4.2494-4.25-4.2494c-2.346 0-4.249 1.9025-4.249 4.2494 0 2.3469 1.903 4.2495 4.249 4.2495Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.341 71.7457c2.347 0 4.249-1.9026 4.249-4.2495s-1.902-4.2494-4.249-4.2494c-2.347 0-4.249 1.9025-4.249 4.2494 0 2.3469 1.902 4.2495 4.249 4.2495Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.446 60.9586c0-4.552-3.69-8.242-8.241-8.242-4.552 0-8.242 3.69-8.242 8.242v7.9853c0 4.5519 3.69 8.242 8.242 8.242 4.551 0 8.241-3.6901 8.241-8.242v-7.9853Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.037 72.9225V89.5a.3572.3572 0 0 0 .149.2842.3565.3565 0 0 0 .318.0473 13.036 13.036 0 0 0 2.438-1.2795 11.7867 11.7867 0 0 0 2.11-1.9706.3432.3432 0 0 0 .084-.2288V72.6237a11.2707 11.2707 0 0 1-5.099.2988Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.148 59.8425-1.621 6.01h2.704",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.146 58.5724a2.1107 2.1107 0 0 1 2.905.3736",
    stroke: "#0D1317",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.542 58.5724a2.1002 2.1002 0 0 0-2.899.3736",
    stroke: "#0D1317",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.351 63.1487c.31 0 .561-.2509.561-.5604a.5605.5605 0 0 0-1.121 0c0 .3095.251.5604.56.5604Z",
    fill: "#0D1317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.277 63.1487c.31 0 .56-.2509.56-.5604a.5597.5597 0 0 0-.56-.5603.5604.5604 0 0 0 0 1.1207Z",
    fill: "#0D1317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.277 65.8525a3.5969 3.5969 0 0 1-.525 1.6121 3.602 3.602 0 0 1-1.203 1.1942 3.6015 3.6015 0 0 1-1.616.5121 3.6 3.6 0 0 1-1.671-.283",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.041 237.544v176.395h42.236V255.107h9.447v158.832h42.236V237.544h-93.919Z",
    fill: "#0D1317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.026 408.265v16.428c-57.4352 0-54.4046 43.129-54.4046 43.129h96.6596v-59.557h-42.255Z",
    fill: "#fff",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.964 454.999H54.9141",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.974 408.265v16.428c57.435 0 54.405 43.129 54.405 43.129h-96.66v-59.557h42.255Z",
    fill: "#fff",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.035 454.999h94.05",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.147 197.357c25.797 0 46.71-20.029 46.71-44.736 0-24.707-20.913-44.736-46.71-44.736s-46.709 20.029-46.709 44.736c0 24.707 20.912 44.736 46.709 44.736Z",
    fill: "#07B2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.147 185.771c19.117 0 34.615-14.842 34.615-33.15 0-18.309-15.498-33.151-34.615-33.151-19.118 0-34.616 14.842-34.616 33.151 0 18.308 15.498 33.15 34.616 33.15Z",
    fill: "#07B2FD",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.367 145.845a3.27 3.27 0 0 1 .957-.369c.389-.089.787-.133 1.186-.131h17.516c.134.003.268-.02.394-.069.125-.049.24-.122.337-.215.098-.094.175-.205.229-.329.054-.123.083-.256.086-.391v-4.945a1.0296 1.0296 0 0 0-.086-.391 1.0117 1.0117 0 0 0-.229-.328 1.0177 1.0177 0 0 0-.337-.216 1.043 1.043 0 0 0-.394-.069h-7.472c-.135.003-.269-.02-.395-.069a1.046 1.046 0 0 1-.338-.215 1.0301 1.0301 0 0 1-.23-.328 1.0212 1.0212 0 0 1-.087-.392v-2.396a1.038 1.038 0 0 0-.086-.391 1.0117 1.0117 0 0 0-.229-.328 1.0208 1.0208 0 0 0-.337-.215c-.126-.049-.26-.073-.394-.069h-6.883a1.007 1.007 0 0 0-.395.069 1.033 1.033 0 0 0-.569.543c-.054.124-.084.257-.087.391v3.4h-1.251c-1.289-.013-2.573.171-3.806.547-1.106.334-2.14.873-3.049 1.587-.877.709-1.6 1.589-2.125 2.587a10.0716 10.0716 0 0 0-1.064 3.507v1.252a9.1 9.1 0 0 0 .999 3.521 8.1365 8.1365 0 0 0 2.181 2.61c.922.72 1.972 1.259 3.095 1.588 1.224.356 2.494.533 3.769.523h9.25c.58.079 1.135.287 1.625.607.197.139.354.326.457.544.103.217.148.458.132.698.008.296-.064.588-.211.845-.145.241-.349.442-.593.584a3.25 3.25 0 0 1-.933.373c-.39.087-.788.131-1.187.131h-17.515a1.018 1.018 0 0 0-.394.07.9939.9939 0 0 0-.338.215c-.097.093-.175.205-.229.328a1.014 1.014 0 0 0-.085.391v4.941a1.018 1.018 0 0 0 .314.719c.097.093.212.167.338.215.125.049.259.073.394.07h9.194c.135-.003.269.021.395.071.125.049.24.123.337.216.097.094.175.206.229.33.054.123.083.256.085.391v2.391c.003.135.033.268.087.392a1.033 1.033 0 0 0 .569.543c.126.049.26.072.395.069h6.883a1.0208 1.0208 0 0 0 .96-.613c.054-.123.083-.256.086-.391v-2.47c.003-.253.1-.495.273-.679.173-.184.409-.297.661-.316.823-.07 1.637-.227 2.428-.467a9.3584 9.3584 0 0 0 3.049-1.587 8.2688 8.2688 0 0 0 2.125-2.592 9.9829 9.9829 0 0 0 1.055-3.432V157.365a9.8517 9.8517 0 0 0-1.013-3.511 7.8794 7.8794 0 0 0-2.148-2.592 9.338 9.338 0 0 0-3.082-1.569 13.1735 13.1735 0 0 0-3.801-.523h-9.325a3.1795 3.1795 0 0 1-1.583-.598 1.504 1.504 0 0 1-.589-1.293c-.008-.296.065-.588.211-.846.144-.242.346-.444.588-.588Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.848 173.41a8.1055 8.1055 0 0 1-2.088 2.382 8.1072 8.1072 0 0 1-2.842 1.401 8.1198 8.1198 0 0 1-3.161.207 8.1153 8.1153 0 0 1-2.999-1.02l-23.4412-13.822a8.116 8.116 0 0 1-2.3819-2.089 8.1151 8.1151 0 0 1-1.6073-6.002 8.119 8.119 0 0 1 5.9496-6.781 8.1212 8.1212 0 0 1 6.16.811l23.4408 13.823a8.1189 8.1189 0 0 1 3.781 4.93c.557 2.08.265 4.296-.811 6.16Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.797 117.611c-3.8839-2.243-8.8498-.913-11.0915 2.97s-.9104 8.848 2.9735 11.091l32.259 18.625c3.884 2.243 8.849.913 11.091-2.97 2.242-3.883.911-8.849-2.973-11.091l-32.259-18.625Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1173 133.525c-3.884-2.242-8.8497-.912-11.0915 2.971-2.2417 3.883-.9105 8.848 2.9734 11.091l30.4718 17.593c3.883 2.242 8.849.912 11.091-2.971 2.242-3.883.91-8.848-2.973-11.091l-30.4717-17.593Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2286 99.49c-3.8839-2.2425-8.8497-.9126-11.0915 2.97-2.2417 3.883-.9105 8.849 2.9734 11.091l27.1795 15.693c3.884 2.242 8.85.913 11.092-2.97 2.241-3.883.91-8.849-2.974-11.091L97.2286 99.49Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.592 164.809-29.8947-17.456",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.496 151.701-32.953-18.777",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.07 130.505-24.5016-13.837",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.011 173.41a8.1021 8.1021 0 0 0 2.087 2.382 8.1152 8.1152 0 0 0 2.84 1.401 8.116 8.116 0 0 0 3.16.207 8.1043 8.1043 0 0 0 2.998-1.02l23.442-13.822a8.1345 8.1345 0 0 0 2.383-2.088 8.122 8.122 0 0 0 1.402-2.841c.276-1.03.347-2.104.208-3.161a8.1052 8.1052 0 0 0-1.019-3.001 8.1189 8.1189 0 0 0-4.93-3.781 8.1212 8.1212 0 0 0-6.16.811l-23.441 13.823a8.095 8.095 0 0 0-2.383 2.088 8.1067 8.1067 0 0 0-1.608 6.003c.14 1.057.487 2.076 1.021 2.999Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.799 136.237c-3.884 2.242-5.215 7.208-2.973 11.091 2.241 3.883 7.207 5.212 11.091 2.97l32.259-18.625c3.884-2.243 5.215-7.208 2.973-11.091-2.241-3.883-7.207-5.213-11.091-2.971l-32.259 18.626Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.268 151.118c-3.884 2.243-5.215 7.208-2.974 11.091 2.242 3.883 7.208 5.213 11.092 2.971l30.471-17.594c3.884-2.242 5.215-7.208 2.974-11.091-2.242-3.882-7.208-5.212-11.092-2.97l-30.471 17.593Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.444 115.187c-3.884 2.242-5.215 7.208-2.974 11.091 2.242 3.883 7.208 5.213 11.092 2.97l27.179-15.692c3.884-2.243 5.215-7.208 2.974-11.091-2.242-3.8833-7.208-5.2132-11.092-2.9707l-27.179 15.6927Z",
    fill: "#E8E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.264 164.809 29.894-17.456",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.359 151.701 32.954-18.777",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.785 130.505 24.501-13.837",
    stroke: "#0D1317",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h308v468H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPessoaEmPe);
export default __webpack_public_path__ + "static/media/pessoa-em-pe.a8b86fee67542f1bcc2c1f29c912b016.svg";
export { ForwardRef as ReactComponent };